<mat-form-field class="w-full">
  <mat-label>{{ field.label | localize }}</mat-label>
  <mat-chip-grid class="p-4" #chipList [formControl]="field.control" [required]="field.required">
    @for (chip of field.control.value ?? []; track chip; let i = $index) {
      <mat-chip-row [value]="chip" [selectable]="false" [selected]="false" [removable]="true" (removed)="removeChip(i)">
        {{ chip }}
        @if (!field.readonly) {
          <mat-icon class="icon-size-5" matChipRemove [svgIcon]="'heroicons_solid:minus-circle'"></mat-icon>
        }
      </mat-chip-row>
    }
    <input [matChipInputFor]="chipList" [placeholder]="field.placeholder | localize" [matChipInputAddOnBlur]="true" [formControl]="searchCtrl" [readonly]="field.readonly"
      [matChipInputSeparatorKeyCodes]="separators" (matChipInputTokenEnd)="add($event)" [matAutocomplete]="ac">
      <mat-autocomplete #ac="matAutocomplete" (optionSelected)="selected($event)" [displayWith]="displayFn">
        @for (option of options; track option) {
          <mat-option [value]="option.name">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-chip-grid>

    @if (!field.control.disabled && field.control.touched && field.control.errors) {
      <mat-error>
        @if (field.control.hasError('required')) {
          {{ 'errorRequiredField' | transloco }}
        }
        @if (field.control.hasError('minlength')) {
          {{ 'errorMinLengthField' | transloco:{ requiredLength: field.control.errors.minlength.requiredLength } }}
        }
        @if (field.control.hasError('maxlength')) {
          {{ 'errorMaxLengthField' | transloco:{ requiredLength: field.control.errors.maxlength.requiredLength } }}
        }
      </mat-error>
    }
  </mat-form-field>